export default __webpack_public_path__ + "static/media/lava-ui-lg-3.50d22c5d.webp";